import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useGolferStore } from '../store/GolferStore'
import { useMetaStore } from '../store/MetaStore'
import GroupEntryView from '../views/GroupEntryView'

const GroupEntryController = () => {
  const eventId = useMetaStore((state) => state.eventId)
  const group = useGolferStore((state) => state.group)
  const setGroup = useGolferStore((state) => state.setGroup)
  const setGroupRounds = useGolferStore((state) => state.setGroupRounds)
  const apiKey = useMetaStore((state) => state.apiKey)
  const validateLogin = useMetaStore((state) => state.validateLogin)
  const logout = useMetaStore((state) => state.logout)
  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  const setErrorMsg = useMetaStore((state) => state.setErrorMsg)
  const populateActiveGolfers = useGolferStore((state) => state.populateActiveGolfers)

  const navigate = useNavigate()
  const [tempGroup, setTempGroup] = useState(group)

  useEffect(() => {
    if (!validateLogin()) {
      console.log('Login validation failed')
      useMetaStore.getState().setErrorMsg('Login validation failed')
      console.error('Login validation failed')
      if (eventId) {
        navigate('/event/signin?eventId=' + eventId)
      } else {
        navigate('/error')
      }
    } else {
      console.log('Login validation succeeded - populating golfers')
      populateActiveGolfers(true)
    }

    setPageTitle('Group Setup')
  }, [])

  const handleCheckboxChange = async (golferId) => {
    setErrorMsg('')
    let grp = [...tempGroup]
    if (grp.includes(golferId)) {
      grp.splice(grp.indexOf(golferId), 1)
    } else {
      if (!grp.includes(golferId)) {
        grp.push(golferId)
      }
    }

    setTempGroup(grp)
  }

  const onSubmit = async () => {
    try {
      if (tempGroup?.length > 0) {
        const rounds = await axios.post(
          '/gskapi/rounds/init',
          { group: tempGroup, eventId },
          { headers: { 'api-token': apiKey } }
        )
        setGroupRounds(rounds.data?.rounds)
        setGroup([...tempGroup])

        navigate('/scoreentry')
      } else {
        setErrorMsg('Select at least one golfer')
        return
      }
    } catch (error) {
      logout()
      useMetaStore.getState().setErrorMsg(error)
      navigate('/error')
      console.error(error)
    }
  }

  return (
    <div>
      <GroupEntryView
        tempGroup={tempGroup}
        onCheckboxChange={handleCheckboxChange}
        onSubmit={onSubmit}
        logout={async () => {
          await logout()
          navigate('/event/signin?eventId=' + eventId)
        }}
      />
    </div>
  )
}

export default GroupEntryController
